
module.exports = {


    // 个人学习系统班
    personalLearnClass: {
        title: '个人学习系统班',
        info1: '概述：长期系统课程，适合想系统提升管理能力的企业领导者、管理者，包括',
        info2: '总裁项目、英才项目、资本项目',
        info3: '三大经典类型，专注于企业战略和领导力的提升，配套实战模型工具和有效解决方案，助力学员企业长久稳定发展。',
        projectList: {
            item1: {
                projectText: {
                    title: '总裁班',
                    info: '想要获得个人提升的企业总裁',
                },
                projectInfo: {
                    title1: '快速提高自我认知',
                    title2: '推动企业行稳致远',
                }
            },
            item2: {
                projectText: {
                    title: '英才班',
                    info: '想成为总裁左右手的企业高管',
                },
                projectInfo: {
                    title1: '从业务专家到管理高手',
                    title2: '从个人成功到团队成功',
                }
            },
            item3: {
                projectText: {
                    title: '资本班',
                    info: '对企业资本发展有规划的总裁',
                },
                projectInfo: {
                    title1: '提升资本运营实战能力',
                    title2: '有效链接资本与圈层资源',
                }
            },
        },
        table: {
            header: {
                head1: '项目简称',
                head2: '总裁项目',
                head3: '英才项目',
                head4: '资本项目',
            },
            data: [
                {
                    head1: '项目全称',
                    head2: '博商总裁班',
                    head3: '商界英才行动突破训战营',
                    head4: '民企资本运营实战项目',
                },
                {
                    head1: '适用对象',
                    head2: '企业创始人',
                    head3: '企业高管',
                    head4: '企业创始人',
                },
                {
                    head1: '面临痛点',
                    head2: ['1. 企业增长困难', '2. 运营管理无力', '3. 缺乏有效资源'],
                    head3: ['1. 个人工作缺少成就感', '2. 团队散漫、协作困难', '3. 组织绩效无法达成'],
                    head4: ['1. 资本运营有盲区', '2. 融资渠道匮乏', '3. 公司财税不规范', '4. 顶层架构不合理'],
                },
                {
                    head1: '课程目标',
                    head2: ['提升总裁三大核心能力', '——战略、运营、领导力'],
                    head3: ['1. 成为老板的左右手', '2. 激励团队，高效运营', '3. 实现流程化管理'],
                    head4: ['1.培养资本运营能力', '2.搭建资源对接平台', '3.加强公司规范治理', '4.资本运营实现转型升级'],
                },
                {
                    head1: '课程模块',
                    head2: ['《战略7步——激发持续增长》', '《商业模式创新——寻找新盈利区》', '《运营管控——驱动战略执行》', '《大财务思维——降本增效数据化管理》', '《销售管理密码——打造销冠铁军》', '《人才战略——支撑企业绩效突破》', '《共赢领导力——让组织和团队共赢》'],
                    head3: ['1. 成就自我', '《管理者的角色定位与认知》', '《公众演讲与有效沟通》', '2. 赢得结果', '《战略执行与目标管控》', '《决策者的财务思维》', '《组织绩效改进工作坊》', '3. 打造团队', '《选人用人：团队搭建与人才选拔》', '《人才培养与薪酬激励》', '《员工辅导与激发》'],
                    head4: ['1. 资本思维', '《企业家资本思维与投融资战略》', '《资本游戏与班级团队打造训练营》',
                        '2. 商业设计', '《商业底层逻辑与模式创新》',
                        '3. 规范治理', '《财务分析与商业价值》', '《公司治理与顶层设计》', '《企业股权设计与激励》',
                        '4. 产融联动', '《创新融资策略》', '《企业价值评估》', '《私募股权投资》', '《多层次资本市场与企业资本运作路径》', '《企业并购与重组》'],
                },
                {
                    head1: '学制',
                    head2: '15个月',
                    head3: '10个月',
                    head4: '1年',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '费用',
                    head2: '9.9万',
                    head3: '4.28万',
                    head4: '9.9万',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        }
    },
    // 陪跑系列
    accompanyRunSeries: {
        title: '陪跑系列',
        info1: '概述：长期陪伴学员落地执行的项目，适合执行条件欠缺、需要教练陪伴的团队组织，包括战略、组织、财务、人力等方面的指导和定制化内训，理论结合实践，帮助企业拿到结果、突破增长瓶颈，少走弯路。',
        projectList: {
            item1: {
                projectText: {
                    title: '战略教练陪跑项目',
                    info: '经营面临人、财、物困扰的企业团队',
                },
                projectInfo: {
                    title1: '实现从战略到执行的闭环',
                    title2: '打造一个能打胜仗的团队',
                }
            },
            item2: {
                projectText: {
                    title: '引爆组织90天',
                    info: '需要单点解决某个经营问题的企业团队',
                },
                projectInfo: {
                    title1: '突破目标拿到结果',
                    title2: '引爆组织快速增长',
                }
            },
            item3: {
                projectText: {
                    title: '博商·灯塔计划',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectInfo: {
                    title1: '跟更有结果的人学习',
                    title2: '成为行业的先锋',
                }
            },
        },
        table: {
            header: {
                head1: '项目分类',
                head2: '战略教练陪跑项目',
                head3: '引爆组织90天',
                head4: '博商·灯塔计划',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '创始人、高管等',
                    head3: '创始人、高管等',
                    head4: '创始人',
                },
                {
                    head1: '面临痛点',
                    head2: '企业经营过程中的人、财、物问题',
                    head3: ['1. 组织散漫', '2. 目标难以实现'],
                    head4: ['1. 陷入增长瓶颈', '2. 管理问题沉积', '3. 经营日益复杂', '4. 员工能力滞后'],
                },
                {
                    head1: '课程目标',
                    head2: ['完成从战略到执行的闭环，实现：', '1. 一个突破性目标结果', '2. 一个可执行跟踪机制', '3. 一套团队有效激励工具', '4. 一个打胜仗的团队文化'],
                    head3: ['1. 合理设置核心业务目标', '2. 设计激励措施', '3. 突破目标拿到结果'],
                    head4: ['1. 吸取实战经验，减少踩坑', '2. 解决企业增长突破', '3. 企业产业资源链接'],
                },
                {
                    head1: '课程模块',
                    head2: '《战略教练陪跑项目》',
                    head3: '《引爆组织90天训战营》',
                    head4: ['《博商·灯塔计划 薄连明-企业突破》', '《博商·灯塔计划 卫哲-增长破圈》'],
                },
                {
                    head1: '学制',
                    head2: '6个月',
                    head3: '3个月',
                    head4: '6个月',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '深圳/上海',
                },
                {
                    head1: '费用',
                    head2: '79.8万',
                    head3: '49.8万',
                    head4: '19.8万',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: '财务陪跑',
                    info: '需搭建财务体系 促进业财融合的企业团队',
                },
                projectInfo: {
                    title1: '用财务数据支撑',
                    title2: '企业经营发展',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        table2: {
            header: {
                head1: '项目分类',
                head2: '财务陪跑',
                head3: '销售陪跑',
                head4: '人力陪跑',
                head5: '定制化企业内训',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '创始人、财务团队',
                    head3: '老板、销售团队',
                    head4: '老板、人力资源负责人+核心高管',
                    head5: '企业核心团队',
                },
                {
                    head1: '面临痛点',
                    head2: ['1. 员工与老板想法割裂 ', '2. 财务系统存在风险', '3. 企业增长受限'],
                    head3: ['1. 销售流程缺乏 ', '2. 销售管理混乱', '3. 销售人才难以培养'],
                    head4: ['1. 人才难招，人岗不匹配', '2. 人才成长速度慢', '3. 人效低影响产出'],
                    head5: ['1. 外部机构和老师选择把不准', '2. 课程体验及培训效果不可控', '3. 有效人才培养的方案难编制'],
                },
                {
                    head1: '课程目标',
                    head2: ['1. 实现团队同频共振', '2. 建立财务管理体系控风险', '3. 持续创造利润'],
                    head3: ['1. 收获独家销售流程', '2. 获得有效销售工具', '3. 打造金牌销售团队'],
                    head4: ['1. 激活人才优势', '2. 建立人才培养、激励体系', '3. 提升组织能力'],
                    head5: ['1. 针对企业现状和人员评估分析', '2. 帮助学员及组织全面成长'],
                },
                {
                    head1: '课程模块',
                    head2: ['《后总裁财务管控系统》', '《业财融合陪跑项目》'],
                    head3: '《销售致胜陪跑项目》',
                    head4: '《组织能力提升陪跑项目》',
                    head5: ['《管理陪跑》', '《团队陪跑》', '《专业提升系列》', '《全员素质提升系列》'],
                },
                {
                    head1: '学制',
                    head2: '3-6个月',
                    head3: '3-12个月',
                    head4: '3个月',
                    head5: '详询',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                    head5: '全国',
                },
                {
                    head1: '费用',
                    head2: '详询',
                    head3: '详询',
                    head4: '详询',
                    head5: '详询',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                    head5: '点击下载',
                },
            ]
        }
    },
    // 领跑系列
    lead: {
        title: '领跑系列',
        info1: '分为"企业经营管理"及"自媒体营销"两类咨询服务：',
        info2: '企业经营管理咨询：适合具备一定规模、希望寻求更大突破、实现全面升级的企业，提供运营效率、组织能力、销售管理、财务合规以及常年财税咨询服务。',
        info3: '自媒体营销咨询：适合希望在新媒体、短视频、直播等新媒体领域实现突破的决策者、管理者和项目负责人，提供内容定位、爆款视频策略、团队搭建等咨询服务。',
        info4:"企业经营管理深度咨询",
        info5: "自媒体领域深度咨询",
        projectList: {
            item1: {
                projectText: {
                    title: '运营效率升级',
                    info: '想要通过建立一套系统，实现经营闭环的企业',
                },
                projectInfo: {
                    title1: '提升内部效率',
                    title2: '帮助企业持续增长',
                }
            },
            item2: {
                projectText: {
                    title: '组织能力提升',
                    info: '想要通过建立一套科学组织发展模式，来实现经营目标的企业',
                },
                projectInfo: {
                    title1: '赋能团队',
                    title2: '助力组织效能提升',
                }
            },
            item3: {
                projectText: {
                    title: '销售管理打造',
                    info: '想要规范销售体系，打造一支销售铁军的企业',
                },
                projectInfo: {
                    title1: '打造持续赢单 ',
                    title2: '的销售管理体系',
                }
            },
        },
        table: {
            header: {
                head1: '项目分类',
                head2: '运营效率升级咨询',
                head3: '组织能力提升咨询',
                head4: '销售管理打造咨询',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '企业团队',
                    head3: '企业团队',
                    head4: '企业团队',
                },
                {
                    head1: '面临痛点',
                    head2: ['1. 管理实效、无人可用','2. 瓶颈突出、激励脱钩','3. 职责不明、目标不清' ],
                    head3: ['1. 中高层思想意见不统一、导致内耗','2. 员工工作效率低下，老板员工天天忙， 见不到绩效','3. 管理者、员工责任心缺失、互相推诿','4. 管理者不愿意培养下属，缺少人才'],
                    head4: ['1. 销售项目无法推进', '2. 销售谈单困难', '3. 没有适配的销售工具'],
                },
                {
                    head1: '项目目标',
                    head2: [' 1. 建系统', '2. 强组织', '3. 破瓶颈'],
                    head3: ['1. 规划经营蓝图', '2. 实现上下协同', '3. 夯实组织系统'],
                    head4: [ ' 1. 打造1支销售铁军', '2. 建立1套业绩成交系统', '3. 实现1-2个核心订单突破'],
                },
                {
                    head1: '项目内容',
                    head2: ['1. 建运营管控系统', '2. 强组织运营能力', '3. 破核心经营瓶颈'],
                    head3: ['1. 激活组织绩效', '2. 点燃人才动力', '3. 升级人才能力'],
                    head4: ['1. 谋定全局、排兵布阵', '2. 打造“狼性”销售铁军', '3. 破成交瓶颈，促业绩提升'],
                },
                {
                    head1: '学制',
                    head2: '6个月',
                    head3: '6个月',
                    head4: '6个月',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '费用',
                    head2: '根据企业情况具体报价',
                    head3: '根据企业情况具体报价',
                    head4: '根据企业情况具体报价',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        },
        projectList2: {
            item1: {
                projectText: {
                    title: '账务合规咨询/常年财税咨询',
                    info: '想要降本增效，实现企业合规，做大做强的企业',
                },
                projectInfo: {
                    title1: '让咨询更落地',
                    title2: '让财税更合规',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        projectList4: {
            item1: {
                projectText: {
                    title: '自媒体领域深度咨询',
                    info: '想入局短视频及直播领域的企业团队',
                },
                projectInfo: {
                    title1: '紧抓短视频直播风口',
                    title2: '构建线上营销新场景',
                }
            },
            item2: {
                projectText: {
                    title: '销售陪跑',
                    info: '业绩增长遭遇瓶颈的企业团队',
                },
                projectInfo: {
                    title1: '打破企业销售瓶颈',
                    title2: '长期持续提高业绩',
                }
            },
            item3: {
                projectText: {
                    title: '人力陪跑',
                    info: '面临招人难、育人难、用人难的企业团队',
                },
                projectInfo: {
                    title1: '有效激活人才优势',
                    title2: '全面提升组织能力',
                }
            },
            item4: {
                projectText: {
                    title: '定制化企业内训',
                    info: '需提高公司整体管理水平、员工专业能力的企业团队',
                },
                projectInfo: {
                    title1: '提升公司的经营管理水平',
                    title2: '及员工素质',
                }
            },
        },
        table2: {
            header: {
                head1: '项目分类',
                head2: '账务合规咨询',
                head3: '销售常年财税咨询陪跑',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '企业团队',
                    head3: '企业团队',
                },
                {
                    head1: '面临痛点',
                    head2: ["1.财税不规范存在风险", "2.成本高利润低"],
                    head3: ["1.财务报表支撑不了项目决策", "2.对最新税法政策了解不及时", "3.财务人员专业性有待提升"],
                },
                {
                    head1: '项目目标',
                    head2: ["1. 企业风险可视化", "2. 合规整改政策依据", "3. 企业纳税结构合规优化", "4. 报表自查风险可控", "5. 解决成本票据合规、资金合规", "6. 降低企业成本，提升企业利润",],
                    head3: ["1. 透视企业风险", "2. 财务团队构建、业财融合", "3. 资金合规，合理分配", "4. 每个决策都有数据依据", "5. 培养符合企业的财务人员", "6. 合法节税，保证公司财富安全", "7. 精准预算，降本增效", "8. 家族财富安全传承，保值、增值",],
                },
                {
                    head1: '项目内容',
                    head2: ["1.企业体检报告", "2. 历史问题梳理", "3.顶层架构设计", "4.企业税务规划", "5.税务报表审核",],
                    head3: ["1. 建立财务支撑体系", "2. 建立管理报表体系", "3. 建立会计核算体系", "4. 建立资金管控体系", "5. 建立财务分析体系", "6. 建设财务管理制度", "7. 建立税务管理体系", "8. 建立财务团队胜任力",],
                },
                {
                    head1: '学制',
                    head2: '6个月',
                    head3: '12个月',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                },
                {
                    head1: '费用',
                    head2: '69.98万',
                    head3: '100万',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                },
            ]
        },
        projectList3: {
            item1: {
                projectText: {
                    title: '战略教练陪跑项目',
                    info: '经营面临人、财、物困扰的企业团队',
                },
                projectInfo: {
                    title1: '实现从战略到执行的闭环',
                    title2: '打造一个能打胜仗的团队',
                }
            },
            item2: {
                projectText: {
                    title: '引爆组织90天',
                    info: '需要单点解决某个经营问题的企业团队',
                },
                projectInfo: {
                    title1: '突破目标拿到结果',
                    title2: '引爆组织快速增长',
                }
            },
            item3: {
                projectText: {
                    title: '博商·灯塔计划',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectInfo: {
                    title1: '跟更有结果的人学习',
                    title2: '成为行业的先锋',
                }
            },
        },
        table3: {
            header: {
                head1: '项目分类',
                head2: '创美短视频营销咨询领跑',
                head3: '创美直播营销咨询领跑',
                head4: '创美短视频&直播营销咨询领跑',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '企业CEO、项目负责人',
                    head3: '企业CEO、项目负责人',
                    head4: '企业CEO、项目负责人',
                },
                {
                    head1: '面临痛点',
                    head2: ["1.不了解短视频营销打法", "2.内容定位不清晰", "3.不了解传播逻辑",],
                    head3: ["1.不了解直播起盘方法", "2.缺乏流量和转化技巧", "3.主播团队不够专业",],
                    head4: ["1.短视频入局困难", "2.直播入局困难",],
                },
                {
                    head1: '课程目标',
                    head2: ["1.短视频账号清晰定位", "2.找到内容差异点", "3.实现流量变现",],
                    head3: [
                        '1. 规划经营蓝图', '2. 实现上下协同', '3. 夯实组织系统'
                    ],
                    head4: ["1.选准符合企业的直播模式", "2.提升直播间流量和转化", "3.搭建专业主播团队",],
                },
                // {
                //   head1: '项目内容',
                //   head2: ['1. 建运营管控系统', '2. 强组织运营能力', '3. 破核心经营瓶颈'],
                //   head3: ['1. 激活组织绩效', '2. 点燃人才动力', '3. 升级人才能力'],
                //   head4: ['1. 谋定全局、排兵布阵', '2. 打造“狼性”销售铁军', '3. 破成交瓶颈，促业绩提升'],
                // },
                {
                    head1: '学制',
                    head2: '3个月',
                    head3: '3个月',
                    head4: '3个月',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '费用',
                    head2: '29.8万',
                    head3: '29.8万',
                    head4: '49.8万',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        },

    },
    onLine: {
        title: '线上系列',
        info1: '概述：博商小麦线上学习课堂，适合想要随时随地学习、时间碎片化的企业家或管理者，汇聚了博商180+精品课程视频，包括但不限于商业模式、股权设计、财税管理、盈利增长、销售管理等10大经实践验证的管理方法论，让学员提升管理认知，掌握方法从而落地。',
        info2:"随时随地",
        info3:"想学就学",
        info4:"经过实战",
        info5:"检验的课程",
        info6:"经过实战<br>能用",
        info7:"了解更多课程 前往博商小麦",
        projectList: {
            item1: {
                projectText: {
                    title: '博商小麦',
                    info: '只能碎片化学习的创业者、职场精英',
                },
                projectInfo: {
                    title1: '100+实战导师指路',
                    title2: '管理不走弯路',
                }
            },
            item2: {
                projectText: {
                    title: '引爆组织90天',
                    info: '需要单点解决某个经营问题的企业团队',
                },
                projectInfo: {
                    title1: '突破目标拿到结果',
                    title2: '引爆组织快速增长',
                }
            },
            item3: {
                projectText: {
                    title: '博商·灯塔计划',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectInfo: {
                    title1: '跟更有结果的人学习',
                    title2: '成为行业的先锋',
                }
            },
        },
    },
    // 团队共学研习社
    teamLearnTrainSociety: {
        title: '团队共学研习社',
        info1: '短期集训课程，适合需要提升某项垂直领域能力的团队。通过突破市场、突破效率、突破资源、突破模式4大维度课程，快速提升团队实操能力。',
        projectList: {
            item1: {
                projectInfo: {
                    title: '突破市场',
                    info: '',
                },
                projectText: [
                    {
                        title: '营销系统：',
                        text: '解密打造品类冠军的营销方法论'
                    },
                    {
                        title: '新媒体营销：',
                        text: '解锁新媒体营销玩法，打通短视频直播公转私促复购 ，强化流量获客能力'
                    },
                    {
                        title: '销售管理：',
                        text: '提升大客户赢单率和销售团队业绩掌握度'
                    },
                ]
            },
            item2: {
                projectInfo: {
                    title: '突破效率',
                    info: '',
                },
                projectText: [
                    {
                        title: '组织人才：',
                        text: '搭建组织进化基石，激活人才管理体系，激发组织合力潜力'
                    },
                    {
                        title: '运营管控：',
                        text: '解锁新媒体营销玩法，打打造运营管控系统，用管控机制流程机制代替人制依赖通短视频直播公转私促复购 ，强化流量获客能力'
                    },
                ]
            },
            item3: {
                projectInfo: {
                    title: '突破资源',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: '财税控本：',
                        text: '防范税务风险，合法节税，提升资金周转效率，打造财税支撑业务资源的价值'
                    },
                    {
                        title: '股权设计：',
                        text: '规避股权架构风险 ，合理设计激励实现散财人聚，升级企业资源 ，强化流量获客能力'
                    },
                    {
                        title: '资本融资：',
                        text: '突围企业投融资难点，收获外界资源、加速企业增长'
                    },
                ]
            },
            item4: {
                projectInfo: {
                    title: '突破模式',
                    info: '在管理上无法获得进一步突破的创始人',
                },
                projectText: [
                    {
                        title: '商业模式：',
                        text: '梳理诊断商业模式，聚焦盈利找到破局口'
                    },
                    {
                        title: '战略：',
                        text: '基于产业价值链上寻找突破点，挖掘核心竞争优势'
                    },
                ]
            },
        },
        table: {
            header0: {
                head1: '项目分类',
                head2: '突破市场',
            },
            header: {
                head1: '模块',
                head2: '营销系统',
                head3: '新媒体营销',
                head4: '销售管理',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '创始人合伙人、品牌/营销负责人',
                    head3: '创始人合伙人、新媒体业务操盘人',
                    head4: '创始人合伙人、销售总监骨干',
                },
                {
                    head1: '面临痛点',
                    head2: ['1. 缺乏全面的营销认知', '2. 碎片化进行品牌规划、爆品打造'],
                    head3: ['1. 对新媒体一知半解', '2. 不会打通流量变现和转化', '3. 获客成本高，只能打价格战'],
                    head4: ['1. 老板缺乏对业务团队业绩管理的掌控感', '2. 销售团队没有战斗力'],
                },
                {
                    head1: '课程目标',
                    head2: ['1. 掌握系统的营销方法', '2. 探索爆品、强化品牌，实现产品溢价'],
                    head3: ['1. 解密流量，玩转短视频直播', '2. 打通私域，促进留存、复购'],
                    head4: ['1. 结合导师实战经验，转化成适合中小企业的销售管理打法', '2. 提升大客户赢单率和销售团队业绩掌握度'],
                },
                {
                    head1: '最新课程',
                    head2: '《赢在F8营销系统》',
                    head3: ['《赢在短视频》', '《赢在直播》', '《赢在私域》', '《赢在本地生活》'],
                    head4: '《赢在销售》',
                },
                {
                    head1: '学制',
                    head2: '2～3天（视具体课程而定）',
                    head3: '2～3天（视具体课程而定）',
                    head4: '2～3天（视具体课程而定）',
                },
                {
                    head1: '建议人数',
                    head2: '至少2人就读',
                    head3: '至少2人就读',
                    head4: '至少2人就读',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '费用',
                    head2: '具体课程 不同费用 详见折页',
                    head3: '具体课程 不同费用 详见折页',
                    head4: '具体课程 不同费用 详见折页',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        },
        table2: {
            header0: {
                head1: '项目分类',
                head2: '突破效率',
            },
            header: {
                head1: '模块',
                head2: '组织人才',
                head3: '运营管控',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '创始人合伙人、人力总监等高管',
                    head3: '创始人合伙人、职业经理人（高管/中层骨干）',
                },
                {
                    head1: '面临痛点',
                    head2: ['1. 难推动组织改革的', '2. 人才选用育留难的', '3. 组织内缺乏凝聚力和自我驱动力'],
                    head3: ['1.组织运行/生产/交付等各类环节效率下降、发展迟滞', '2.企业没有清晰经营目标，目标难落地'],
                },
                {
                    head1: '课程目标',
                    head2: ['1. 解决人才培养、招聘等难点问题', '2. 有效构建企业文化并落地', '3.设计激励机制，激发团队合力'],
                    head3: ['培养用机制流程管理的人才，', '打造企业运营管理系统闭环'],
                },
                {
                    head1: '最新课程',
                    head2: ['《赢在人才》（独家）', '《赢在组织进化》', '《赢在绩效》', '《团队致胜》（独家）'],
                    head3: ['《赢在流程：用流程复制成功》', '《赢在运营》', '《引爆组织能力》'],
                },
                {
                    head1: '学制',
                    head2: '2～3天（视具体课程而定）',
                    head3: '2～3天（视具体课程而定）',
                },
                {
                    head1: '建议人数',
                    head2: '至少2人就读',
                    head3: '至少2人就读',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                },
                {
                    head1: '费用',
                    head2: '具体课程 不同费用 详见折页',
                    head3: '具体课程 不同费用 详见折页',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                },
            ]
        },
        table3: {
            header0: {
                head1: '项目分类',
                head2: '突破资源',
            },
            header: {
                head1: '模块',
                head2: '财税控本',
                head3: '股权设计',
                head4: '资本融资',
            },
            data: [
                {
                    head1: '适用对象',
                    head2: '创始人、财务总监等决策层',
                    head3: '企业CEO、总经理等决策层',
                    head4: '创始人合伙人等决策层',
                },
                {
                    head1: '面临痛点',
                    head2: ['1.现金流压力', '2.股权架构不合理', '3.不了解税收政策，多缴或漏缴', '4.成本高利润低'],
                    head3: ['1.股权设计笼统、唯亲主义', '2.企业结构不规范，存在风险', '3.员工积极性低，影响效率', '4.股权变动影响企业上市'],
                    head4: ['1.有意投融资，但毫无头绪的', '2.融资屡屡碰壁'],
                },
                {
                    head1: '课程目标',
                    head2: ['1.提升资金周转效率', '2.调整股权和交易结构', '3.合理合法节税', '4.有效管控成本，提高利润'],
                    head3: ['1.合理规范股权架构，规避风险', '2.设计激励和合伙人机制', '3.实现股东利益共享和风险共担', '4.加速公司增长，支撑上市大计'],
                    head4: '助力解决投融资难点',
                },
                {
                    head1: '最新课程',
                    head2: ['《赢在财务》', '《赢在税务》'],
                    head3: ['《赢在股权激励》', '《赢在股权系统》', '《赢在股权模式》'],
                    head4: '《赢在资本》',
                },
                {
                    head1: '学制',
                    head2: '2～3天（视具体课程而定）',
                    head3: '3天2晚',
                    head4: '2～3天（视具体课程而定）',
                },
                {
                    head1: '建议人数',
                    head2: '至少2人就读',
                    head3: '至少2人就读',
                    head4: '至少2人就读',
                },
                {
                    head1: '区域',
                    head2: '全国',
                    head3: '全国',
                    head4: '全国',
                },
                {
                    head1: '费用',
                    head2: '具体课程 不同费用 详见折页',
                    head3: '具体课程 不同费用 详见折页',
                    head4: '具体课程 不同费用 详见折页',
                },
                {
                    head1: '下载折页',
                    head2: '点击下载',
                    head3: '点击下载',
                    head4: '点击下载',
                },
            ]
        },
        table4: {
            header0: {
                head1: '项目分类',
                head2: '突破模式',
            },
            header: {
                head1: '模块',
                head2: '商业模式',
                head3: '战略',
            },
            data: [
                {
                    head1: '',
                    head2: ['线上：商业模式特训营', '更多线下课程 敬请期待'],
                    head3: '更多线下课程 敬请期待',
                },
            ]
        },
    },

}


// WEBPACK FOOTER //
// ./src/lang/class/zh.js